import { render, staticRenderFns } from "./PageSpinner.vue?vue&type=template&id=4f194307"
import script from "./PageSpinner.vue?vue&type=script&lang=js"
export * from "./PageSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports